import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

class Slider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sliders: [],
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.fetchSliders();
    }

    componentDidUpdate(prevProps, prevState) {
        // Reinitialize Revolution Slider when sliders data is loaded
        if (prevState.sliders !== this.state.sliders && this.state.sliders.length > 0 && !this.state.loading) {
            this.reinitializeRevolutionSlider();
        }
    }

    reinitializeRevolutionSlider = () => {
        // Wait for DOM to update with new slider content
        setTimeout(() => {
            if (window.jQuery && window.jQuery.fn.revolution) {
                console.log("Reinitializing Revolution Slider...");
                
                try {
                    // Destroy existing slider instance if it exists
                    if (window.revapi1) {
                        window.revapi1.revkill();
                        delete window.revapi1;
                    }

                    // Reinitialize the slider
                    window.revapi1 = window.jQuery("#rev_slider_1_1").show().revolution({
                        sliderType: "standard",
                        jsFileLocation: "//www.ascconstruction.co.in/revolution/js/",
                        sliderLayout: "fullscreen",
                        dottedOverlay: "none",
                        delay: 9000,
                        navigation: {
                            keyboardNavigation: "off",
                            keyboard_direction: "horizontal",
                            mouseScrollNavigation: "off",
                            mouseScrollReverse: "default",
                            onHoverStop: "off",
                            touch: {
                                touchenabled: "on",
                                touchOnDesktop: "off",
                                swipe_threshold: 75,
                                swipe_min_touches: 1,
                                swipe_direction: "horizontal",
                                drag_block_vertical: false
                            },
                            arrows: {
                                style: "gyges",
                                enable: true,
                                hide_onmobile: false,
                                hide_under: 768,
                                hide_onleave: false,
                                tmp: '',
                                left: {
                                    h_align: "left",
                                    v_align: "center",
                                    h_offset: 0,
                                    v_offset: 0
                                },
                                right: {
                                    h_align: "right",
                                    v_align: "center",
                                    h_offset: 0,
                                    v_offset: 0
                                }
                            }
                        },
                        viewPort: {
                            enable: true,
                            outof: "pause",
                            visible_area: "80%",
                            presize: false
                        },
                        responsiveLevels: [1240, 1024, 778, 480],
                        visibilityLevels: [1240, 1024, 778, 480],
                        gridwidth: [1240, 1024, 778, 480],
                        gridheight: [868, 768, 960, 720],
                        lazyType: "none",
                        parallax: {
                            type: "scroll",
                            origo: "enterpoint",
                            speed: 400,
                            speedbg: 0,
                            speedls: 0,
                            levels: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 47, 48, 49, 50, 51, 55],
                        },
                        shadow: 0,
                        spinner: "spinner0",
                        stopLoop: "off",
                        stopAfterLoops: -1,
                        stopAtSlide: -1,
                        shuffle: "off",
                        autoHeight: "off",
                        hideThumbsOnMobile: "off",
                        hideSliderAtLimit: 0,
                        hideCaptionAtLimit: 0,
                        hideAllCaptionAtLilmit: 0,
                        debugMode: false,
                        fallbacks: {
                            simplifyAll: "off",
                            nextSlideOnWindowFocus: "off",
                            disableFocusListener: false,
                        }
                    });
                    
                    console.log("✅ Revolution Slider reinitialized successfully");
                } catch (error) {
                    console.error("❌ Error reinitializing Revolution Slider:", error);
                }
            } else {
                console.warn("⚠️ Revolution Slider jQuery plugin not available yet");
                // Retry after a short delay
                setTimeout(this.reinitializeRevolutionSlider, 500);
            }
        }, 100);
    }

    fetchSliders = async () => {
    try {
        this.setState({ loading: true, error: null });
        
        const apiUrl = `${process.env.REACT_APP_API_URL}/api/sliders/active`;
        console.log("🔄 Fetching from:", apiUrl);

        const response = await fetch(apiUrl);



        const result = await response.json();
        if (response.ok && result.success) {
            console.log("✅ Data to be set in state:", result.data);
            this.setState({ 
                sliders: result.data,
                loading: false 
            });
        } else {
            console.error('❌ API Error:', result);
            this.setState({ 
                error: result.error || 'Failed to load sliders',
                loading: false 
            });
        }
    } catch (error) {
        console.error('❌ Fetch Error:', error);
        this.setState({ 
            error: 'Error fetching sliders',
            loading: false 
        });
    }
}

    getImageForDevice = (slider) => {
        const baseUrl = process.env.REACT_APP_API_URL || '';
        
        let imagePath;
        if (window.innerWidth <= 768) {
            imagePath = slider.mobileImage || slider.desktopImage;
        } else if (window.innerWidth <= 1024) {
            imagePath = slider.tabletImage || slider.desktopImage;
        } else {
            imagePath = slider.desktopImage;
        }

        // If already a full URL, return as is
        if (imagePath && (imagePath.startsWith('http://') || imagePath.startsWith('https://') || imagePath.startsWith('//'))) {
            return imagePath;
        }
        
        // If it's a relative path, prepend the base URL
        if (imagePath && baseUrl) {
            const cleanImagePath = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
            return `${baseUrl}/${cleanImagePath}`;
        }
        
        return imagePath;
    }

    getAnimationData = (slider, index) => {
        const { location } = this.props;
        
        if (location.pathname === "/") {
            return {
                classnames: "tp-caption tp-resizeme text-white font-heading font-weight-600 px-[10px] md:px-0",
                classtext: "tp-caption tp-resizeme text-white font-heading font-weight-700 px-[10px] md:px-0",
                classbtn: "tp-caption",
                datavset1: "['-134','-134','-134','-134']",
                datavset2: "['-63','-63','-63','-63']",
                datavset3: "['2','2','2','2']",
                datavset: "['106','106','106','106']"
            };
        } else if (location.pathname === "/home-02") {
            return {
                classnames: "tp-caption tp-resizeme text-white font-heading font-weight-600",
                classtext: "tp-caption tp-resizeme text-white font-heading font-weight-700",
                classbtn: "tp-caption",
                datavset1: "['-134','-134','-134','-134']",
                datavset2: "['-63','-63','-63','-63']",
                datavset3: "['2','2','2','2']",
                datavset: "['106','106','106','106']"
            };
        } else {
            return {
                classnames: "tp-caption tp-resizeme text-white font-heading font-weight-600",
                classtext: "tp-caption tp-resizeme text-white font-heading font-weight-700",
                classbtn: "tp-caption",
                datavset1: "['-134','-134','-134','-134']",
                datavset2: "['-63','-63','-63','-63']",
                datavset3: "['2','2','2','2']",
                datavset: "['106','106','106','106']"
            };
        }
    }

    renderSliderContent = (slider, animationData) => {
        const { location } = this.props;

        if (location.pathname === "/") {
            return (
                <>

                <div className="#">

                    <div className={animationData.classnames} 
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset1} 
                         data-fontsize="['20','20','20','16']" 
                         data-lineheight="['70','70','40','24']" 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={700} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        {slider.header}
                    </div>
                    
                    <div className={animationData.classtext} 
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset2} 
                         data-fontsize="['52','52','42','32']" 
                         data-lineheight="['65','65','45','35']" 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={1000} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        {slider.title}
                    </div>
                    
                    <div className={`${animationData.classtext}  text-custom`}
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset3} 
                         data-fontsize="['52','52','42','32']" 
                         data-lineheight="['65','65','45','35']" 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={1000} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        {slider.description}
                    </div>

                    <div className={animationData.classbtn} 
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset} 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={1000} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        <Link to="/contact" className="themesflat-button bg-accent big">
                            <span>PARTNER WITH US</span>
                        </Link>
                    </div>

                    </div>
                </>
            );
        } else if (location.pathname === "/home-02") {
            return (
                <>

                 <div className="px-1 md:px-0">
                    <div className={animationData.classnames} 
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset1} 
                         data-fontsize="['20','20','20','16']" 
                         data-lineheight="['70','70','40','24']" 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={700} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        {slider.header}
                    </div>
                    
                    <div className={animationData.classtext} 
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset2} 
                         data-fontsize="['52','52','42','32']" 
                         data-lineheight="['65','65','45','35']" 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={1000} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        WE WILL BE HAPPY
                    </div>
                    
                    <div className={animationData.classtext} 
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset3} 
                         data-fontsize="['52','52','42','32']" 
                         data-lineheight="['65','65','45','35']" 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={1000} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        TO TAKE CARE OF YOUR WORK
                    </div>

                    <div className={animationData.classbtn} 
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset} 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={1000} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        <Link to="/contact" className="themesflat-button bg-accent big">
                            <span>GET IN TOUCH</span>
                        </Link>
                    </div>

                    </div>
                </>
            );
        } else {
            return (
                <>

                 <div className="px-1 md:px-0">
                    <div className={animationData.classnames} 
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset1} 
                         data-fontsize="['20','20','20','16']" 
                         data-lineheight="['70','70','40','24']" 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={700} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        {slider.header}
                    </div>
                    
                    <div className={animationData.classtext} 
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset2} 
                         data-fontsize="['52','52','42','32']" 
                         data-lineheight="['65','65','45','35']" 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={1000} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        {slider.title}
                    </div>
                    
                    <div className={`${animationData.classtext}  text-custom`}
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset3} 
                         data-fontsize="['18','18','18','18']" 
                         data-lineheight="['35','35','25','15']" 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={1000} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on"
                         
                           style={{
    fontWeight: 500,
    lineHeight: "28px",
    marginTop: "35px",
    fontSize: "18px",
  }}
  
  >
                        {slider.description}
                    </div>

                    <div className={animationData.classbtn} 
                         data-x="left"
data-hoffset="['30','30','20','15']"
                         data-y="['middle','middle','middle','middle']" 
                         data-voffset={animationData.datavset} 
                         data-width="full" data-height="none" 
                         data-whitespace="normal" 
                         data-transform_idle="o:1;" 
                         data-transform_in="y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;s:2000;e:Power4.easeInOut;" 
                         data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;" 
                         data-mask_in="x:0px;y:[100%];" 
                         data-mask_out="x:inherit;y:inherit;" 
                         data-start={1000} 
                         data-splitin="none" 
                         data-splitout="none" 
                         data-responsive_offset="on">
                        <Link to="/contact" className="themesflat-button bg-accent big">
                            <span>LEARN MORE</span>
                        </Link>
                    </div>

                    </div>
                </>
            );
        }
    }

    render() {
        const { sliders, loading, error } = this.state;

        if (loading) {
            return (
                <div id="rev_slider_1_1" className="rev_slider fullscreenbanner">
                    <ul>
                        <li data-transition="fade">
                            <div className="flex items-center justify-center h-96">
                                <div className="text-white">Loading sliders...</div>
                            </div>
                        </li>
                    </ul>
                </div>
            );
        }

        if (error) {
            return (
                <div id="rev_slider_1_1" className="rev_slider fullscreenbanner">
                    <ul>
                        <li data-transition="fade">
                            <div className="flex items-center justify-center h-96">
                                <div className="text-white">Error loading sliders</div>
                            </div>
                        </li>
                    </ul>
                </div>
            );
        }

        if (sliders.length === 0) {
            return (
                <div id="rev_slider_1_1" className="rev_slider fullscreenbanner">
                    <ul>
                        <li data-transition="fade">
                            <div className="flex items-center justify-center h-96">
                                <div className="text-white">No sliders available</div>
                            </div>
                        </li>
                    </ul>
                </div>
            );
        }

        return (
            <div id="rev_slider_1_1" className="rev_slider fullscreenbanner">
                <ul>
                    {sliders.map((slider, index) => {
                        const animationData = this.getAnimationData(slider, index);
                        const imageSrc = this.getImageForDevice(slider);
                        
                        return (
                            <li data-transition="fade" key={slider._id || slider.id}>
                                <img 
                                    src={imageSrc} 
                                    alt={slider.title || "ASC Construction Hero"} 
                                    data-bgposition="center center" 
                                    data-no-retina 
                                    onError={(e) => {
                                        console.error("❌ Failed to load image:", imageSrc);
                                    }}
                                />
                                <div className="slide-overlay"></div>
                                {this.renderSliderContent(slider, animationData)}
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

export default withRouter(Slider);